import {useState, useEffect} from 'react';

export const useOptimistic = <T,>(input: T) => {
    const [value, setValue] = useState(input);

    useEffect(  () => {
        setValue(input);
    }, [input]);

    return [value, setValue] as const;
};
